import { Injectable } from '@angular/core';
import { Datipreventivo } from '../model/datipreventivo';
import { DatiEle } from '../archiviodatipreventivo/dati-ele';
import { DatiGas } from '../archiviodatipreventivo/dati-gas';
import { DatiDual } from '../archiviodatipreventivo/dati-dual';
import { DatiRisparmio } from '../archiviodatipreventivo/dati-risparmio';
import { DatiSpecial } from '../archiviodatipreventivo/dati-special';
import { DatiTelefonia } from '../archiviodatipreventivo/dati-telefonia';

@Injectable()
export class DatipreventivoService {

  private lst: Array<Datipreventivo>;

  constructor() {

    this.lst = [
      DatiEle.dati(),
      DatiGas.dati(),
      DatiDual.dati(),
      DatiRisparmio.dati(),
      DatiSpecial.dati(),
      DatiTelefonia.dati()
    ]

   }

   public getDati(id_comodity:number): Datipreventivo {

    return this.lst.filter( o => o.id_comodity== id_comodity)[0];
   };

 // test e

}



// WEBPACK FOOTER //
// ./src/app/service/datipreventivo.service.ts